import { BoundingBox } from '@bpd-library/types';

import { mergeBoundingBoxes } from './geometry';

const COUNTRY_BBOX: {
    [key: string]: BoundingBox;
} = {
    nl: [3.33390071158434, 50.7503661060614, 7.22749998189678, 53.6436329908026],
    de: [5.98865807458, 47.3024876979, 15.0169958839, 54.983104153],
};

/**
 * @description Returns a merged bounding box for an array of countries
 * @param {(('de' | 'nl' | 'be' | 'lu')[])} countryIsoCodes
 * @return {*} BoundingBox
 */
const getCountryBoundingBox = (countryIsoCodes: ('de' | 'nl' | 'be' | 'lu')[]): BoundingBox => {
    const boundingBoxes = countryIsoCodes
        ?.map((countryIsoCode) => COUNTRY_BBOX[countryIsoCode])
        .filter((bbox) => !!bbox);

    const mergedBoundingBox = mergeBoundingBoxes(boundingBoxes);

    return mergedBoundingBox;
};

export { COUNTRY_BBOX, getCountryBoundingBox };
